module.exports = __webpack_public_path__ + "static/media/dish.696a252e.svg";